import { RouteComponentProps } from 'react-router-dom';
import qs from 'qs';

const getCategoryFromQueryParams = (
  CATEGORIES: string[],
  location: RouteComponentProps['location']
) => {
  if (!CATEGORIES[0]) {
    throw new Error('At least one category is needed');
  }

  const { search } = location;
  let selectedCategory = CATEGORIES[0];

  if (search) {
    const params = qs.parse(search, { ignoreQueryPrefix: true });
    const { category } = params;

    if (category && typeof category === 'string') {
      const findCategory = CATEGORIES.find(
        listCategory => listCategory.toLowerCase() === category.toLowerCase()
      );

      if (findCategory) {
        selectedCategory = findCategory;
      }
    }
  }

  return selectedCategory;
};

export default getCategoryFromQueryParams;
